module.exports = __webpack_public_path__ + "img/sgcenc.1c394b42.svg";